import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../lib/auth-context';
import { useEnterpriseOrg } from '../context/EnterpriseOrgContext';
import { LoadingFallback } from './LoadingFallback';

interface EnterpriseProtectedRouteProps {
  children: React.ReactNode;
}

export function EnterpriseProtectedRoute({ children }: EnterpriseProtectedRouteProps) {
  const { user, loading } = useAuth();
  const { activeOrgId, hasActiveOrgAccess, orgMembershipsLoading } = useEnterpriseOrg();
  const location = useLocation();

  if (loading || orgMembershipsLoading) {
    return <LoadingFallback fullScreen message="Loading enterprise workspace..." />;
  }

  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }

  if (!activeOrgId || !hasActiveOrgAccess) {
    return (
      <Navigate
        to="/enterprise"
        replace
        state={{ from: location.pathname, enterpriseGuard: 'active-org-required' }}
      />
    );
  }

  return <>{children}</>;
}
